import { createStore, combineReducers } from 'redux'

import { qi } from './qi.js';
import { user } from './user.js';

let reducers =  combineReducers({
  qi, user
});

let store = createStore(reducers);

export {
    store, 
    reducers
}


// WEBPACK FOOTER //
// ./src/reducers/index.js